import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { COMPANY, SERVICES } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-forest text-bone">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="mb-8">
              <div className="inline-block bg-bone px-6 py-5 rounded-sm shadow-lg">
                <img
                  src="/brand/logo-full.png"
                  alt="Novacore Services Private Limited"
                  className="h-16 md:h-20 w-auto object-contain"
                />
              </div>
            </div>
            <p className="font-display text-3xl md:text-4xl leading-tight tracking-tight max-w-md">
              Great companies are built on great hires — let&rsquo;s build yours.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta-contact"
              className="inline-flex items-center gap-2 mt-8 border-b border-bone/40 pb-1 text-bone hover:text-terracotta-soft hover:border-terracotta-soft transition-colors"
            >
              Start a conversation <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-bone/60 mb-5">Services</div>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services#${s.slug}`}
                    className="text-bone/80 hover:text-bone text-sm"
                    data-testid={`footer-service-${s.slug}`}
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-bone/60 mb-5">Reach us</div>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 shrink-0" strokeWidth={1.5} />
                <span className="text-bone/85 leading-relaxed">{COMPANY.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 shrink-0" strokeWidth={1.5} />
                <a
                  href={`mailto:${COMPANY.email}`}
                  data-testid="footer-email"
                  className="text-bone/85 hover:text-bone"
                >
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 shrink-0" strokeWidth={1.5} />
                <a
                  href={`tel:${COMPANY.phone.replace(/\s/g, "")}`}
                  data-testid="footer-phone"
                  className="text-bone/85 hover:text-bone"
                >
                  {COMPANY.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-bone/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs text-bone/60">
            © {new Date().getFullYear()} {COMPANY.legalName}. All rights reserved.
          </div>
          <div className="flex items-center gap-6 text-xs text-bone/60">
            <span>CIN: U78100GJ2026PTC180634</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
